import { clickTrackProviderFactoryAdobeEddl } from '@sxm-core/domains/data-layer/state-tracking-adobe-eddl';
import { CLICK_TRACK_PROVIDER } from '@sxm-core/tracking/click-track-provider';

export function providerClickTrackAdobe() {
    return [
        {
            provide: CLICK_TRACK_PROVIDER,
            useFactory: clickTrackProviderFactoryAdobeEddl,
        },
    ];
}
